import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconClipboard: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ?? 16}
      height={height ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6666 2.66683H12C12.3536 2.66683 12.6927 2.80731 12.9428 3.05735C13.1928 3.3074 13.3333 3.64654 13.3333 4.00016V13.3335C13.3333 13.6871 13.1928 14.0263 12.9428 14.2763C12.6927 14.5264 12.3536 14.6668 12 14.6668H3.99996C3.64634 14.6668 3.3072 14.5264 3.05715 14.2763C2.8071 14.0263 2.66663 13.6871 2.66663 13.3335V4.00016C2.66663 3.64654 2.8071 3.3074 3.05715 3.05735C3.3072 2.80731 3.64634 2.66683 3.99996 2.66683H5.33329M7.99996 7.3335H10.6666M7.99996 10.6668H10.6666M5.33329 7.3335H5.33996M5.33329 10.6668H5.33996M5.99996 1.3335H9.99996C10.3681 1.3335 10.6666 1.63197 10.6666 2.00016V3.3335C10.6666 3.70169 10.3681 4.00016 9.99996 4.00016H5.99996C5.63177 4.00016 5.33329 3.70169 5.33329 3.3335V2.00016C5.33329 1.63197 5.63177 1.3335 5.99996 1.3335Z"
        stroke={color ?? "#F97316"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
